<template>
    <div 
        class="flag-card"
        ref="flag"
        :class="{'pending': postulation, 'selected': selected}"
        >
        <div class="flag-content">
            <div 
                class="flag" 
                :style="{
                    'background-image':
                    'url(' +
                    require(`@/assets/images/flags/${flag}.svg`) +
                    ')'
                }"
                >
            </div>
            <div class="flag-name">{{name}}</div>
        </div>
        <div 
            v-if="postulation"
            class="icon-pending"
            >
            <span class="material-icons">
                watch_later
            </span>
        </div>
        <div class="bubble-pending" v-if="postulation">
            <div class="bubble-pending-title">
                {{ postulation.status.description }}
            </div>
            <div class="bubble-pending-description mt-3" v-if="postulation.html_message" v-html="postulation.html_message">
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {}
    },
    props: ['flag', 'name','postulation','selected']
}
</script>